import { render, staticRenderFns } from "./EmployerLogoUpload.vue?vue&type=template&id=b72a8aa6&scoped=true"
import script from "./EmployerLogoUpload.vue?vue&type=script&lang=ts"
export * from "./EmployerLogoUpload.vue?vue&type=script&lang=ts"
import style0 from "./EmployerLogoUpload.vue?vue&type=style&index=0&id=b72a8aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a8aa6",
  null
  
)

export default component.exports